import React from 'react'
import './styleTea.css';
import Gallery from "react-photo-gallery"
import { photos } from "./photos";
import nonGMO from "../../images/nongmo.png"
import sustain from "../../images/sustainable.png"
import quality from "../../images/quality-check.png"

const Tea = () => {
    return (
        <div id="tea" className="style-tea-main">
            <div className="style-tea-hero">
                <h1 className="style-tea-heading">Our CTC Teas</h1>
                <p className="style-tea-intro">
                    <strong>CTC</strong> (Crush, Tear, Curl) tea is a popular type of black tea that is widely consumed 
                    all over the world. It is a process that involves rolling, breaking and shaping the tea leaves 
                    which creates a perfect cup.
                </p>
            </div>

            <div className="style-tea-content">
                <div className="style-tea-left" data-aos="fade-right" data-aos-duration="500" data-aos-offset="130">
                    <div className="style-tea-info-card">
                        <h2 className="style-tea-subheading">Premium Quality</h2>
                        <p className="style-tea-paragraph">
                            From the strong and robust flavor of our OF (Orange Pekoe Fannings) grade, to the fine and 
                            delicate taste of our BOPSM (Broken Orange Pekoe Small), we have something to 
                            suit every taste preference.
                        </p>
                    </div>

                    <div className="style-tea-info-card">
                        <h2 className="style-tea-subheading">Versatile Options</h2>
                        <p className="style-tea-paragraph">
                            Our Dust, PD, BOP and BP grades are excellent options 
                            for those who are looking for a flavorful cup of tea without any fuss. Perfect for 
                            tea bags, blends, and as a standalone tea.
                        </p>
                    </div>

                    <div className="style-tea-info-card">
                        <h2 className="style-tea-subheading">Why Choose CTC?</h2>
                        <p className="style-tea-paragraph">
                            Perfect for those who appreciate a strong, full-bodied cup of tea that's easy to brew 
                            and quick to prepare. Affordable yet high in quality, our teas reflect our commitment 
                            to excellence.
                        </p>
                    </div>

                    <div className="style-symbols-container">
                        <div className="style-item">
                            <img className="style-symbols" src={nonGMO} alt="Non-GMO certification"/>
                            <span className="style-caption">NON-GMO</span>
                        </div>
                        <div className="style-item">
                            <img className="style-symbols" src={sustain} alt="Sustainability certification"/>
                            <span className="style-caption">SUSTAINABLE</span>
                        </div>
                        <div className="style-item">
                            <img className="style-symbols" src={quality} alt="Quality check certification"/>
                            <span className="style-caption">QUALITY CHECK</span>
                        </div>
                    </div>
                </div>

                <div className="style-tea-right" data-aos="fade-left" data-aos-duration="500" data-aos-offset="130">
                    <div className="style-gallery-container">
                        <Gallery photos={photos} direction="column" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Tea
